<template>
  <cd-navbar class="navbar" sticky transparent>
    <img class="logo" src="@/assets/spring-logo.png" alt="Spring Logo"/>
    <!-- <cd-navbar-brand>
      <cd-navbar-item>
        Spring Financial - Upload Image
      </cd-navbar-item>
    </cd-navbar-brand> -->
  </cd-navbar>
</template>

<script>
/**
 * <component></component>
 * @desc description
 */
export default {
  // Name
  name: 'toolbar',

  // Components
  components: {},

  // Props
  props: {},

  // Mixins
  mixins: [],

  // Data
  data () {
    return {
      msg: 'Hello World'
    }
  },

  // Computed
  computed: {},

  // Watch
  watch: {},

  // Methods
  methods: {},

  // Created
  created () {},

  // Mounted
  mounted () {}
}
</script>

<style scoped lang="scss">
.navbar {
  width: 100%;
  display: flex;
  border-bottom: 2px solid #d8d8d8;
  &.is-sticky {
    box-shadow: none;
  }
  .logo {
    width: 135px;
    display: inline-block;
    margin: auto;
  }
}
</style>
